module.exports = __webpack_public_path__ + "assets/events_insult_black.5517848d.svg";